import styled from '@emotion/styled';
import Image from 'next/image';
import { gray } from '@styles/Colors';
import _ from 'lodash';

const CultureCardContainer = styled.div`
  border: 1px solid ${gray.gray4};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 432px;
  max-height: 432px;
`;

const CultureCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex-shrink: 0;
  align-self: stretch;

  padding-top: 40px;
  padding-left: 40px;
  padding-right: 40px;
`;

const CultureCardContentLeft = styled(CultureCardContent)<{ leftBackgroundColor?: string }>`
  width: 520px;

  border-radius: 8px 0px 0px 8px;
  background-color: ${(props) => props.leftBackgroundColor};
  color: ${(props) => (props.leftBackgroundColor && props.leftBackgroundColor !== gray.gray1 ? '#fff' : 'inherit')};
`;

const CultureCardContentRight = styled(CultureCardContent)`
  border-left: 1px solid ${gray.gray4};
  width: 560px;
`;

const CultureCardContentTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  gap: 28px;
  align-self: stretch;
  white-space: pre-line;
`;

const CultureCardContentText = styled.p`
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
`;

const CultureCardLeftImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
`;

const CultureCardTitle = styled.p`
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  white-space: pre-line;
`;

const BenefitCardNumber = styled.p`
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 44px;
`;

// 왜.. style이 csr때 안먹는가... Image 태그만 그런건가..
const StyledImage = styled(Image)<{ style?: React.CSSProperties }>`
  ${(props) => Object.entries(props.style || {}).map(([key, value]) => `${_.kebabCase(key)}: ${value};`)}
`;

export type Props = {
  readonly cardNumber: string;
  readonly leftBackgroundColor?: string;
  readonly title: string;
  readonly image: {
    readonly src: string;
    readonly width: number;
    readonly height: number;
    readonly style?: React.CSSProperties;
  };
  readonly contents: string[];
};

export default function CultureCard({ cardNumber, leftBackgroundColor = gray.gray1, title, image, contents }: Props) {
  return (
    <>
      <CultureCardContainer>
        <CultureCardContentLeft leftBackgroundColor={leftBackgroundColor}>
          <BenefitCardNumber>{cardNumber}</BenefitCardNumber>
          <CultureCardTitle>{title}</CultureCardTitle>
          <CultureCardLeftImageWrapper>
            <StyledImage alt="culture-image" {...image} />
          </CultureCardLeftImageWrapper>
        </CultureCardContentLeft>

        <CultureCardContentRight>
          <BenefitCardNumber>{cardNumber}</BenefitCardNumber>
          <CultureCardContentTextWrapper>
            {contents.map((content, index) => (
              <CultureCardContentText key={index}>{content}</CultureCardContentText>
            ))}
          </CultureCardContentTextWrapper>
        </CultureCardContentRight>
      </CultureCardContainer>
    </>
  );
}
